import { createCtx } from '@shared/util/context';
import { ControlsActions, ControlsLoadingState, ControlsState, SearchInputState } from '../types';

export const [useControlsState, ControlsStateProvider] = createCtx<ControlsState>();
export const [useControlsActions, ControlsActionsProvider] = createCtx<ControlsActions>();
export const [useSearchInput, SearchInputProvider] = createCtx<SearchInputState>();
export const [useControlsLoading, ControlsLoadingProvider] = createCtx<ControlsLoadingState>();
